/* WorkTriggerTargetsReadonlyTabComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./WorkTriggerTargetsReadonlyTabRenderer");
const PagingWorkTargetDeviceFeed = require("./PagingWorkTargetDeviceFeed"),
    PagingWorkTargetRelatedDevicesFeed = require("./PagingWorkTargetRelatedDevicesFeed"),
    PagingDeviceFeed = require("./PagingDeviceFeed");

const {
    DEVICE_MANAGEMENT_STATES,
    LICENSE_STATUS,
    DEVICE_ENVIRONMENTS,
    DEVICE_CAPTURE_STATUSES,
    AUDIT_STATUSES,
} = require("../../../../../../lmrbcomponents/deviceexplorer/views/device_grid_view/deviceConstants");

class WorkTriggerTargetsReadonlyTabComponent extends EventEmitter {
    constructor(workTriggerDetailsView) {
        super();
        this._workTriggerDetailsView = workTriggerDetailsView;
        this._workTriggerDetailsView._targetViewOpen = true;
        this._sitePaths = this._workTriggerDetailsView._sitePaths;
        this._CustomFieldsEntityClass = _.get(
            this._workTriggerDetailsView,
            "_customFieldEntityDef"
        );
        this._nodeProps = this._workTriggerDetailsView._nodeProps;

        this._gameEditor = workTriggerDetailsView.getGameEditor();
        this._customFieldsWithInherited = {};
        this._customFieldsEntityInstance = {};
        this._method = _.get(this._workTriggerDetailsView._triggerType.getWorkTarget(), "method");
        this._filter = {};
        if (this._method === "query") {
            this._filter = _.get(
                this._workTriggerDetailsView._triggerType.getWorkTarget(),
                "query"
            );
        }

        this._gridKey = "schedule_targets";
        this._workTargetMethod = this.workTarget.method;
        if (this._workTargetMethod === "query") {
            this._pagingFeed = new PagingWorkTargetDeviceFeed({
                feedKey: this._gridKey + "_feed",
                userSession: this.gameEditor.getUserSession(),
                entityDef: this._workTriggerDetailsView.getTargetEntityClass(),
                columnConfig: this.columnConfig,
                filter: _.get(this.workTarget, "query"),
                sort: {name: 1},
                pageSize: 100,
            });
        } else if (this._workTargetMethod === "related") {
            //this._pagingFeed = workTriggerDetailsView._osPlan.startRelatedDevicesFeed();
            this._pagingFeed = new PagingWorkTargetRelatedDevicesFeed({
                feedKey: this._gridKey + "_feed",
                userSession: this.gameEditor.getUserSession(),
                entityDef: workTriggerDetailsView._osPlan,
                columnConfig: this.columnConfig,
                sort: {name: 1},
                pageSize: 100,
            });
        } else {
            let devices = [];
            if (this._method === "multi") {
                devices = _.get(
                    this._workTriggerDetailsView._triggerType.getWorkTarget(),
                    "ids",
                    []
                );
            } else {
                devices = [
                    _.get(this._workTriggerDetailsView._triggerType.getWorkTarget(), "id", []),
                ];
            }
            _.get(this._workTriggerDetailsView._triggerType.getWorkTarget(), "ids", []);
            let filter = {id: {$in: devices}};

            if (
                _.get(this._workTriggerDetailsView._triggerType.getWorkTarget(), "category", "") ===
                "construct"
            ) {
                filter = {nodeId: {$in: devices}};
            }

            this._pagingFeed = new PagingDeviceFeed({
                feedKey: this._gridKey + "_feed",
                userSession: this.gameEditor.getUserSession(),
                entityDef: this._workTriggerDetailsView.getTargetEntityClass(),
                columnConfig: this.columnConfig,
                sort: {name: 1},
                pageSize: 100,
                filter,
            });
        }
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        this._workTriggerDetailsView.on(
            "Shutdown",
            (this._onShutdown = this._onShutdown.bind(this))
        );
        this._workTriggerDetailsView.on(
            "WorkTypeChanged",
            (this._onWorkTypeChanged = this._onWorkTypeChanged.bind(this))
        );
    }

    _unregisterListeners() {
        this._workTriggerDetailsView.removeListener("Shutdown", this._onShutdown);
        this._workTriggerDetailsView.removeListener("WorkTypeChanged", this._onWorkTypeChanged);
    }

    shutdown() {
        return Promise.all([])
            .then(() => {
                this.emit("Shutdown");
                this._unregisterListeners();
                this._workTriggerDetailsView._targetViewOpen = undefined;
                this._workTriggerDetailsView = undefined;
            })
            .catch((err) => {
                this.logger.warn(
                    {error: err},
                    "WorkTriggerTargetsReadonlyTabComponent.shutdown() error"
                );
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    get workTriggerDetailsView() {
        return this._workTriggerDetailsView;
    }

    get logger() {
        return this._workTriggerDetailsView._logger;
    }

    get workTarget() {
        return this.getWorkTarget();
    }
    getWorkTarget() {
        return this._workTriggerDetailsView.getWorkTarget();
    }
    set workTarget(t) {
        return this.setWorkTarget(t);
    }
    setWorkTarget(t) {
        return this._workTriggerDetailsView.setWorkTarget(t);
    }
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    set pagingFeed(newPagingFeed) {
        this._pagingFeed = newPagingFeed;
    }
    get pagingFeed() {
        return this._pagingFeed;
    }

    get columnConfig() {
        return {
            name: {
                label: "Name", //`Selected ${this._workTriggerDetailsView.getTargetName()}s`,
                entityColumn: "name",
                width: 160,
                priority: 1,
                sortable: false,
            },
            detectedHostName: {
                label: "Hostname",
                shown: true,
                width: 140,
                priority: 2,
            },
            ip: {
                label: "IP Address",
                path: "connectionInformation.ip",
                shown: true,
                width: 100,
                priority: 3,
            },
            detectedSku: {
                label: "SKUs",
                shown: true,
                width: 140,
                priority: 4,
            },
            detectedOs: {
                label: "OS",
                shown: true,
                priority: 5,
                width: 80,
                options: Object.entries(this._workTriggerDetailsView._osMap).map(([, title]) => ({
                    name: title,
                    title,
                })),
            },
            detectedSoftwareVersion: {
                label: "OS Version",
                shown: true,
                priority: 6,
                width: 80,
            },
            siteCodeName: {
                label: "Site Code Name",
                entityColumn: "siteCodeName",
                width: 100,
            },
        };
    }

    get columnConfigFilter() {
        if (this.columnsFilter) {
            return this.columnsFilter;
        }
        this._deviceEntityDef = this._workTriggerDetailsView.getTargetEntityClass();
        const vendorsMap = this._workTriggerDetailsView._vendorMap,
            accessStatusLabels = this._deviceEntityDef.getAccessStatusLabels();

        //creating a new static DEVICE_TYPES list to pass to filter dropdown for types (via options)
        //TODO: create a non-redundant list directly in the filter
        let typeBaseGroupMap = this._workTriggerDetailsView._typeBaseMap;
        let optionFilterList = {};
        _.sortBy(Object.keys(typeBaseGroupMap)).map(function (key) {
            optionFilterList[key] = {name: typeBaseGroupMap[key], title: typeBaseGroupMap[key]};
        });
        const serversMap = _.get(this._parentView, "_gameEditor.osImageServerList", []).map(
            ({name}) => ({
                title: name,
                name,
            })
        );
        const optionMapAccessStatus = {};
        Object.keys(accessStatusLabels).forEach(
            (accessLabel) =>
                (optionMapAccessStatus[accessLabel] = {
                    name: accessLabel,
                    title: accessStatusLabels[accessLabel],
                })
        );

        const optionMapSitePaths = this._sitePaths.map(({id, path}) => ({
            [id]: path || "/",
        }));

        this.columnsFilter = {
            detectedTypeBase: {
                label: "Type",
                entityColumn: true,
                width: 45,
                resizable: false,
                priority: 1,
                options: optionFilterList,
                dataType: "enum",
                groupable: true,
                shown: true,
            },
            name: {
                label: "Name",
                width: 220,
                dataType: "string",
                shown: true,
                priority: 2,
            },
            description: {
                label: "Description",
                shown: true,
                dataType: "string",
                width: 300,
                priority: 4,
            },
            managementState: {
                label: "Management State",
                groupable: true,
                shown: false,
                options: DEVICE_MANAGEMENT_STATES,
                dataType: "enum",
                width: 140,
                priority: 5,
            },
            environment: {
                label: "Environment",
                shown: true,
                options: DEVICE_ENVIRONMENTS,
                width: 140,
                dataType: "enum",
                priority: 6,
            },
            licensed: {
                label: "Licensed",
                groupable: true,
                shown: false,
                options: LICENSE_STATUS,
                dataType: "boolean",
                width: 140,
                priority: 6,
            },
            ip: {
                label: "IP Address",
                path: "connectionInformation.ip",
                shown: true,
                dataType: "string",
                width: 140,
                priority: 3,
            },
            detectedVendor: {
                label: "Vendor",
                groupable: true,
                shown: true,
                priority: 5,
                dataType: "enum",
                width: 140,
                options: Object.entries(vendorsMap).map(([, title]) => ({name: title, title})),
            },
            detectedHostName: {
                label: "Hostname",
                shown: true,
                dataType: "string",
                priority: 8,
                width: 140,
            },
            detectedOs: {
                label: "OS",
                shown: true,
                priority: 9,
                width: 140,
                dataType: "enum",
                groupable: true,
                options: Object.entries(this._workTriggerDetailsView._osMap).map(([, title]) => ({
                    name: title,
                    title,
                })),
            },
            detectedSoftwareVersion: {
                label: "OS Version",
                shown: true,
                priority: 10,
                dataType: "string",
                width: 140,
                groupable: true,
            },
            detectedSerialNumber: {
                // check name
                label: "Serial Number",
                shown: true,
                groupable: true,
                dataType: "string",
                width: 140,
                priority: 11,
            },
            detectedSku: {
                label: "SKUs",
                shown: true,
                groupable: true,
                dataType: "string",
                width: 140,
                priority: 12,
            },
            detectedUptime: {
                label: "Up Time",
                shown: false,
                width: 120,
                dataType: "string",
                priority: 13,
            },
            elementCount: {
                label: "Elements",
                width: 110,
                dataType: "number",
                shown: false,
                priority: 14,
            },
            fileServerName: {
                // check field
                label: "File Server",
                shown: false,
                options: serversMap,
                dataType: "enum",
                groupable: true,
                priority: 15,
            },
            haPairName: {
                label: "HA Group",
                priority: 18,
                dataType: "string",
            },
            osUpgradedBy: {
                label: "OSM Action By",
                priority: 19,
                dataType: "string",
                groupable: true,
            },
            osUpgradedOn: {
                label: "OSM Action On",
                shown: false,
                priority: 20,
                dataType: "string",
                groupable: true,
            },
            osUpgradeError: {
                label: "OSM Action Error",
                shown: false,
                priority: 21,
                dataType: "string",
                groupable: false,
            },
            osUpgradePlanAction: {
                label: "OS Plan Action",
                shown: false,
                priority: 24,
                dataType: "string",
                groupable: true,
            },
            osUpgradePlanId: {
                label: "OS Plan ID ",
                shown: false,
                priority: 22,
                dataType: "string",
                groupable: false,
            },
            osUpgradePlanName: {
                label: "OS Plan Name",
                shown: false,
                priority: 23,
                dataType: "string",
                groupable: true,
            },
            osUpgradeStatus: {
                label: "OSM Action Status",
                shown: true,
                priority: 18,
                dataType: "enum",
                options: this._getOsPlanDataForAdvancedFilter(
                    this._deviceEntityDef.getOsUpgradeStatusValues()
                ),
                groupable: true,
            },
            useIssu: {
                label: "Non-disruptive",
                width: 80,
                dataType: "boolean",
                description: "Require non-disruptive upgrade",
                shown: false,
                priority: 18,
            },
            vrf: {
                label: "VRF",
                shown: false,
                dataType: "string",
                priority: 16,
            },
            zoneName: {
                label: "Zone",
                shown: false,
                dataType: "string",
                groupable: true,
                width: 160,
                priority: 18,
            },
            configuredInfo: {
                label: "Configured Info",
                width: 160,
                shown: false,
                dataType: "string",
                groupable: true,
                priority: 19,
            },
            configuredType: {
                label: "Configured Type",
                width: 120,
                dataType: "string",
                shown: false,
                groupable: true,
                priority: 19,
            },
            configuredBy: {
                label: "Configured By",
                width: 120,
                shown: false,
                dataType: "string",
                groupable: true,
                priority: 19,
            },
            configuredOn: {
                label: "Configured On",
                width: 160,
                dataType: "string",
                shown: false,
                groupable: false,
                priority: 19,
            },
            accessStatus: {
                label: "Access Status",
                shown: false,
                priority: 26,
                dataType: "enum",
                groupable: true,
                options: optionMapAccessStatus,
            },
            latestHaveIChangedLastChecked: {
                label: "Captured On",
                shown: false,
                dataType: "string",
                priority: 27,
            },
            latestHaveIChanged: {
                label: "Captured Status",
                priority: 28,
                dataType: "enum",
                options: DEVICE_CAPTURE_STATUSES,
                groupable: true,
                shown: true,
            },
            capturedBy: {
                label: "Captured By",
                priority: 29,
                dataType: "string",
                width: 120,
            },
            auditCriticalViolationCount: {
                label: "Critical Violations",
                priority: 30,
                dataType: "number",
                shown: true,
            },
            auditMajorViolationCount: {
                label: "Major Violations",
                priority: 31,
                dataType: "number",
                width: 120,
            },
            auditMinorViolationCount: {
                label: "Minor Violations",
                dataType: "number",
                priority: 30,
            },
            auditInfoViolationCount: {
                label: "Informational Violations",
                priority: 31,
                width: 175,
                dataType: "number",
            },
            auditViolationCount: {
                label: "Total Violations",
                priority: 32,
                width: 120,
                groupable: false,
                dataType: "number",
            },
            auditedOn: {
                label: "Audited On",
                dataType: "string",
                priority: 33,
            },
            auditedBy: {
                priority: 34,
                label: "Audited By",
                dataType: "string",
            },
            auditStatus: {
                label: "Audit Status",
                priority: 35,
                options: AUDIT_STATUSES,
                dataType: "enum",
            },
            lastAuditPolicy: {
                label: "Audit Policy",
                priority: 36,
                dataType: "string",
            },
            sitePath: {
                label: "Site Path",
                priority: 37,
            },
            siteName: {
                label: "Site Name",
                priority: 38,
            },
            siteCodeName: {
                label: "Site Code Name",
                priority: 39,
            },
            siteLocationType: {
                label: "Site Type",
                priority: 40,
            },
            allowSiteAutoAssignment: {
                label: "Allow site auto-assignment",
                priority: 41,
            },
            siteId: {
                label: "Site Path List",
                dataType: "pathlist",
                options: optionMapSitePaths,
            },
        };

        return this.columnsFilter;
    }

    _getOsPlanDataForAdvancedFilter(data) {
        let clonedData = _.clone(data);
        let newObj = {};
        for (let key in clonedData) {
            let value = {};
            value[key] = {
                name: key,
                title: clonedData[key],
            };
            newObj = Object.assign(newObj, value);
        }
        return newObj;
    }

    setCustomFieldsEntity(newOrgInstance) {
        this._customFieldsEntityInstance = newOrgInstance;
        return this._customFieldsEntityInstance;
    }

    retrieveCustomFieldsEntity() {
        if (this._customFieldsEntityInstance && this._customFieldsEntityInstance.shutdown) {
            this._customFieldsEntityInstance
                .shutdown()
                .catch((error) => this._logger.warn({error}));
        }
        return this._CustomFieldsEntityClass
            .retrieveCustomFields(this._gameEditor._activeOrgId)
            .then((customFieldsEntity) => {
                this.setCustomFieldsEntity(customFieldsEntity);
                return customFieldsEntity.loadInheritedFields();
            })
            .then((inheritedFields) => {
                Object.assign(
                    this._customFieldsWithInherited,
                    this._customFieldsEntityInstance.fields,
                    inheritedFields
                );
                return this._customFieldsWithInherited;
            });
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onShutdown() {
        this.shutdown();
    }

    _onWorkTypeChanged(newWorkType, oldWorkType) {
        if (
            newWorkType.targetConstruct !== oldWorkType.targetConstruct ||
            newWorkType.targetEntityType !== oldWorkType.targetEntityType
        ) {
            //
        }
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /*******************************************/
}
module.exports = WorkTriggerTargetsReadonlyTabComponent;
